export default {
  sections: {
    searchSection: {
      label: 'Search',
      buttons: {
        searchIconButton: {
          tooltip: 'Search for items in your BOQ by their name or specification',
        },
      },
    },
    actionsSection: {
      button: {
        clearSelected: {
          label: '{count} Items Selected',
          tooltip: 'Clear selected items',
        },
      },
      buttons: {
        addToCart: {
          tooltip: 'Add selected to cart',
        },
        delete: {
          tooltip: 'Delete selected',
        },
      },
    },
    newItemsSection: {
      label: 'New',
      buttons: {
        addSectionIconButton: {
          tooltip: 'Add section',
        },
        addSubSectionIconButton: {
          tooltip: 'Add sub-section',
        },
        addGroupIconButton: {
          tooltip: 'Add group',
        },
      },
    },
    cartSection: {
      label: 'Cart',
      button: {
        clearCartIconButton: {
          label: 'Clear',
          tooltip: 'Clear the items in your cart',
        },
      },
      buttons: {
        cartIconButton: {
          tooltip: 'View cart',
        },
      },
    },
  },
  messageBox:
    'Welcome to your BOQ Action Bar. This bar contains all the functions and features you might need to build out and work on your BOQ. Try it out!',
};
